import { registerComponent } from '@gig/magic-common';
import PanicBarComponent from './panic-bar.vue.js';

var PanicBar = registerComponent(PanicBarComponent);

export { PanicBar };
